export const BRAND = {
  teal: '#0FA388',
  tealDark: '#052F2A',
  tealMuted: 'rgba(15, 163, 136, 0.14)',
  gold: '#C9A227',
  goldLight: '#E5C866',
  surface: '#F8F9FA',
  text: '#1A1A1A',
  textMuted: '#5C6B68',
  border: 'rgba(5, 47, 42, 0.1)',
};

export const featureAccent = (index) =>
  index % 2 === 0 ? BRAND.teal : BRAND.gold;

export const HERO_PATTERN = {
  backgroundImage: `radial-gradient(circle at 1px 1px, rgba(255,255,255,0.06) 1px, transparent 0)`,
  backgroundSize: '24px 24px',
};
